import { useMutation, useQueryClient } from "@tanstack/react-query";

import { privateApi } from "@/api/axios";
import { messagesQueryOptions } from "@/domains/messages/factories/messages-query-options";
import type { SendMessageRequest } from "@/domains/messages/models/types";

export const useSendMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendMessage,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: messagesQueryOptions.all.queryKey,
      });
    },
  });
};

const sendMessage = async ({ content, threadId }: SendMessageRequest) => {
  await privateApi.post(`/threads/${threadId}/messages`, { content });
};
